/**
 * @module composables/useBooked
 * @description What the system just wrote in the GL by itself — shown app-wide
 * by BookedSnackbar.vue (Maurizio, 2026-10-06: "add it in all places where the
 * system performs a hidden transaction in the GL — so the user is taught and
 * clarified what is happening").
 *
 * The servers add `booked` to the answer of any request that wrote journal
 * entries (accounting lib/booked.js; meals passes it through). The accounting
 * and meals API clients hand every such answer to showBooked() — so a screen
 * needs no code of its own, and the figures are the ledger's, not the screen's.
 */
import { ref } from "vue";

const booked = ref(null); // { title, count, entries: [{ entryNo, date, description, lines }], totals }
const visible = ref(false);

/** Show a `booked` summary from a server answer (ignored when empty). */
export function showBooked(summary) {
  if (!summary || !summary.count) return;
  booked.value = summary;
  visible.value = true;
}

export function useBooked() {
  return { booked, visible, showBooked };
}
